import { graphql } from '../../graphql/generated';

export const THEMES_QUERY = graphql(`
  query Themes {
    themes {
      id
      name
      colorPrimary
      controlItemBgActive
      controlItemBgActiveHover
      colorBgHeader
      colorBgTrigger
      logoData
    }
  }
`);
